<template>
  <div>
    <div id="listWidget" class="mb-4" style="padding-bottom: 5rem;">
      <div>
        <!-- <h4 class="mb-3">이관받기</h4> -->
        
        <!-- 이관받기 단계 안내 -->
        <div class="instruction-card card-item mb-3">
          <div class="instruction-header">
            <i class="fa-solid fa-list-ol me-2 text-primary"></i>
            <span class="instruction-title">이관받기 단계</span>
          </div>
          <div class="instruction-body">
            <div class="instruction-step">
              <div class="step-number">1</div>
              <div class="step-content">
                <span>컨트롤러를 통해 이전 사용자의 데이터를 이관받습니다.</span>
              </div>
            </div>
            <div class="instruction-step">
              <div class="step-number">2</div>
              <div class="step-content">
                <span>컨트롤러 종류에 따라 연결방식이 다르므로 아래의 <strong class="text-primary">컨트롤러 타입</strong>을 선택해주세요.</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 경고 메시지 -->
        <div class="warning-box mb-3">
          <i class="fa-solid fa-triangle-exclamation me-2"></i>
          <span>※ 조명제어기의 경우 한 장치만 AP모드가 활성화 되어 있어야합니다.</span>
        </div>
      </div>

      <!-- 컨트롤러 타입 선택 -->
      <div class="controller-type-select-card card-item mb-3">
        <div class="controller-type-select-card-header">
          <i class="fa-solid fa-microchip me-2 text-primary"></i>
          <span class="controller-type-select-card-title">컨트롤러 타입 선택</span>
        </div>
        <div class="controller-type-select-card-body">
          <div class="row">
            <div class="col-6 mb-3">
              <div 
                class="controller-type-card cursor-pointer" 
                :class="{ 'controller-type-card-selected': selectedControllerType === 'light' }"
                @click="selectControllerType('light')"
              >
                <div class="controller-type-card-body text-center">
                  <i class="fa-regular fa-lightbulb fa-3x mb-3 text-warning"></i>
                  <h6 class="controller-type-card-title">조명제어기</h6>
                  <p class="controller-type-card-text">조명 제어 및 스케줄링</p>
                </div>
              </div>
            </div>
            <div class="col-6 mb-3">
              <div 
                class="controller-type-card cursor-pointer" 
                :class="{ 'controller-type-card-selected': selectedControllerType === 'temp' }"
                @click="selectControllerType('temp')"
              >
                <div class="controller-type-card-body text-center">
                  <i class="fas fa-thermometer-half fa-3x mb-3 text-info"></i>
                  <h6 class="controller-type-card-title">온도조절기</h6>
                  <p class="controller-type-card-text">온도 제어 및 스케줄링</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 다음 버튼 (하단 고정) -->
  <div class="action-button-container-fixed">
    <button
      type="button"
      class="btn btn-primary w-100"
      :disabled="!selectedControllerType"
      @click="onNextStepClick"
    >
      <i class="fa-solid fa-arrow-right me-2"></i>
      다음
    </button>
  </div>
</template>

<script setup>
import { ref, getCurrentInstance, computed, onBeforeMount, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import useMobile from '@/common/hooks/useMobile';

const store = useStore();
const router = useRouter();
const { disConnectWifi } = useMobile();
const { emitter, mobile, logger } =
  getCurrentInstance().appContext.config.globalProperties;

const selectedControllerType = ref('');

onBeforeMount(() => {  
  disConnectWifi();
  emitter.emit('onChangeHeaderSetting',{title:'이관받기',isShowMenu:false,isShowZone:false,isShowProfile:false});    
});
onBeforeUnmount(() =>{
  emitter.emit('onChangeHeaderSetting',{title:'',isShowMenu:true,isShowZone:true,isShowProfile:true});  
})

const showPopAlert = (msg) => {
  emitter.emit('showPopAlert', {
    description: msg,
  });
};

const selectControllerType = (type) => {
  selectedControllerType.value = type;
};

const onNextStepClick = async () => {
  try {
    if (!selectedControllerType.value) {
      showPopAlert('컨트롤러 타입을 선택해주세요.');
      return;
    }

    // 선택된 컨트롤러 타입에 따라 해당 페이지로 이동
    if (selectedControllerType.value === 'light') {
      router.push('/settings/receive/light');
    } else if (selectedControllerType.value === 'temp') {
      router.push('/settings/receive/temp');
    }
  } catch (err) {
    if (err?.length > 0) {
      showPopAlert(err);
    }
  }
};
</script>

<style scoped>
/* instruction-card 스타일 */
.instruction-card {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.instruction-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.instruction-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.instruction-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #212529;
}

.instruction-body {
  padding: 0.75rem 1rem;
}

.instruction-step {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.instruction-step:last-child {
  margin-bottom: 0;
}

.step-number {
  width: 1.5rem;
  height: 1.5rem;
  min-width: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0d6efd;
  color: white;
  border-radius: 50%;
  font-weight: 600;
  font-size: 0.75rem;
}

.step-content {
  flex: 1;
  padding-top: 0.1rem;
  font-size: 0.85rem;
  line-height: 1.6;
  color: #495057;
}

.step-content strong {
  color: #0d6efd;
  font-weight: 600;
}

/* warning-box 스타일 */
.warning-box {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.875rem 1rem;
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 0.5rem;
  color: #856404;
  font-size: 0.875rem;
  line-height: 1.5;
}

.warning-box i {
  color: #ffc107;
  flex-shrink: 0;
  margin-top: 0.125rem;
  font-size: 0.9rem;
}

/* controller-type-select-card 스타일 */
.controller-type-select-card {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.controller-type-select-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.controller-type-select-card-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.controller-type-select-card-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #212529;
}

.controller-type-select-card-body {
  padding: 1rem;
}

/* controller-type-card 스타일 */
.controller-type-card {
  background-color: #ffffff;
  border: 2px solid #e9ecef;
  border-radius: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
  height: 100%;
}

.controller-type-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-color: #0d6efd;
}

.controller-type-card-selected {
  border: 2px solid #0d6efd !important;
  background-color: #f0f7ff;
  box-shadow: 0 2px 8px rgba(13, 110, 253, 0.2);
}

.controller-type-card-body {
  padding: 1.5rem 1rem;
}

.controller-type-card-title {
  font-size: 1rem;
  font-weight: 600;
  color: #212529;
  margin-bottom: 0.5rem;
}

.controller-type-card-text {
  font-size: 0.85rem;
  color: #6c757d;
  margin-bottom: 0;
}

/* 하단 고정 버튼 스타일 */
.action-button-container-fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1rem;
  background-color: #ffffff;
  border-top: 1px solid #e9ecef;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.action-button-container-fixed .btn {
  padding: 0.75rem 1.25rem;
  font-size: 0.95rem;
  font-weight: 500;
  border-radius: 0.5rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.action-button-container-fixed .btn:hover:not(:disabled) {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}

.action-button-container-fixed .btn:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.action-button-container-fixed .btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.cursor-pointer {
  cursor: pointer;
}

/* 모바일 반응형 간격 조정 */
@media (max-width: 768px) {
  #listWidget {
    margin-bottom: 1rem;
    padding-bottom: 5.5rem;
  }

  .instruction-card,
  .warning-box,
  .controller-type-select-card {
    margin-bottom: 1rem;
  }

  .action-button-container-fixed {
    padding: 0.875rem;
  }

  .action-button-container-fixed .btn {
    padding: 0.625rem 1rem;
    font-size: 0.9rem;
  }

  .controller-type-card-body {
    padding: 1rem 0.75rem;
  }
}
</style>
